import Vuex from "vuex";
import attendeeStore from "./attendee.module";
import sponsorsStore from "./sponsors.module";
import ceInfoStore from "./ceInfo.module";
import speakersStore from "./speakers.module";
import agendaStore from "./agenda.module";
import ticketStore from "./ticket.module";
import echoStore from "./echo.module";
import boothStore from "./booth.module";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    attendeeStore,
    agendaStore,
    sponsorsStore,
    ceInfoStore,
    speakersStore,
    ticketStore,
    echoStore,
    boothStore,
  }
});
